import React from 'react'
import Tooltip from 'src/sharedComponent/tooltip'
import { Creation_Approach, Creation_Source } from 'src/constants'

export const customCellRenderer = (params) => {
  return (
    <Tooltip placement="top" content={params?.value || 'NA'}>
      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {params?.value || 'NA'}
      </div>
    </Tooltip>
  )
}

export const shouldCostApproachCellRenderer = (params) => {
  const creationSource =
    params.data.creation_source === Creation_Source.SKU_Management
      ? Creation_Approach.top_down
      : Creation_Approach.bottom_up
  return <div className="d-flex align-items-start">{creationSource}</div>
}
